<template>
  <section style="position: relative;">
    <section class="grid-flex column">
      <!-- filters -->
      <div class="flex-1 w100">
        <div class="flex row w100 middle">
          <div class="flex-1 flex">
            <tabs :data="reportTabs" v-model="currentTab" :disable="checkHaveCampaign" :disableMsg="disableMsg" :key="currentTab" ></tabs>
          </div>
          <div class="flex-1 flex row end w100">
            <div style="margin-right: 8px;" class="flex column no-mobile">
              <label>Editar</label>
              <div class="flex end w100" style="margin-top:12px">
                <div class="button secondary" @click="showModalEdit = true">
                  <i class="fas fa-edit"></i>
                </div>
              </div>
            </div>
            <div class="flex column no-mobile" style="margin-right: 14px;">
              <label>Atualizar</label>
              <div class="flex end w100" style="margin-top:14px">
                <div @click="forceRefreshData()" class="button secondary">
                  <i class="fas fa-sync-alt"></i>
                </div>
              </div>
            </div>
            <div class="flex-1 w100 filter-item">
              <label>Tracking: </label>
              <select class="input" v-model="filters.data.tracking">
                <option v-for="(c, index) in filters.list.listTrack" :key="index" :value="c.value" :selected="c.value === filters.data.tracking">
                  {{ c.label }}
                </option>
              </select>
            </div>
            <div v-if="currentTab!='account'" class="flex-1 w100 filter-item">
              <label>Ordenar por: </label>
              <select class="input" v-model="filters.data.order_by">
                <option v-for="(c, index) in filters.list.listOrderBy" :key="index" :value="c.value" :selected="c.value === filters.data.order_by">
                  {{ c.label }}
                </option>
              </select>
            </div>
            <div v-if="currentTab!='account'" class="flex-1 w100 filter-item">
              <label>Ordenação: </label>
              <select class="input" v-model="filters.data.order">
                <option v-for="(c, index) in filters.list.listOrder" :key="index" :value="c.value" :selected="c.value === filters.data.order">
                  {{ c.label }}
                </option>
              </select>
            </div>
            <ltk-date-picker
              label="Filtro de data"
              v-model="filters.data.date"
              :loading="loading"
            ></ltk-date-picker>
          </div>
        </div>
      </div>
    </section>

    <modal
      title="Editar Colunas"
      :show="showModalEdit"
      @close="showModalEdit = false"
    >
      <div class="content flex column" slot="content">
        <div class="flex column w100">
            <div class="flex-1 w100 litem ">
                Nome da Campanha
              </div>
              <div class="flex-1 w100 litem">
                  Orçamento
              </div>

              <draggable v-model="columns" handle=".drag-handle" animation="200" class="w100">
                <transition-group>
                  <div
                    v-for="col in columns"
                    :key="col.name"
                    class="litem flex-1 txt-center flex middle between w100"
                  >
                    <div class="flex middle">
                      <span class="drag-handle">☰</span>
                      <div style="margin-left: 8px;">{{ col.label }}</div>
                    </div>
                    <m-switch
                      v-model="stats[col.name]"
                    ></m-switch>
                  </div>
                </transition-group>
              </draggable>


        </div>
        <div class="flex column w100">
          <div class="flex w100 center margin-top-l">
            <div class="button secondary" style="margin-right: 8px;" @click="showModalEdit = false">FECHAR</div>

            <div class="button primary" @click="updateDashCampaign()">SALVAR</div>
          </div>
        </div>
      </div>
    </modal>

    <!-- account -->
    <account 
      v-if="currentTab === 'account'" 
      :filters="filters"
      :columns="stats"
      :columnsOrder="columns"
      :accountsFilter="accountSelecteds"
      @accountSelected="addAccount($event)"
      @accountRemoved="removeAccount($event)"
      @cleanAccountSelect="cleanAccount($event)"
    ></account>
    <!-- campaign -->
    <campaign 
      v-if="currentTab === 'campaign'" 
      :filters="filters"
      :columns="stats"
      :columnsOrder="columns"
      :accountsFilter="accountSelecteds"
      :campaignsFilter="campaignsSelecteds"
      @campaignSelected="addCampaign($event)"
      @campaignRemoved="removeCampaign($event)"
      @cleanCampaignSelect="cleanCampaign($event)"
      @refresh="forceRefreshData($event)"
    ></campaign>
    <!-- adgroup -->
    <ad-group 
      v-if="currentTab === 'adgroup'" 
      :filters="filters"
      :columns="stats"
      :columnsOrder="columns"
      :accountsFilter="accountSelecteds"
      :campaignsFilter="campaignsSelecteds"
      :adGroupFilter="adGroupSelecteds"
      @adgSelected="addAdg($event)"
      @adgRemoved="removeAdg($event)"
      @cleanAdgSelect="cleanAdg($event)"
    >
    </ad-group>
    <!-- ad -->
    <ad 
      v-if="currentTab === 'ad'"
      :filters="filters"
      :columns="stats"
      :columnsOrder="columns"
      :accountsFilter="accountSelecteds"
      :campaignsFilter="campaignsSelecteds"
      :adGroupFilter="adGroupSelecteds"
    ></ad>
  </section>
</template>

<script>
import draggable from 'vuedraggable'

import Tabs from "@/components/tabs/Tabs";
import ltkDatePicker from "@/components/datepicker/LtkDatePicker";

import Account from "./Account";
import Campaign from "./Campaign";
import AdGroup from "./AdGroup";
import Ad from "./Ad";
import Modal from "@/components/modal/Modal";
import MSwitch from "@/components/MSwitch.vue";

import {
  getDashCampaign,
  updateDashCampaign,
} from "@/services/dashCampaign";

import moment from "moment";
moment.locale("pt-br");

const EMPTYSTATE = {
    spend: true,
    sales: true,
    sales_cost: true,
    sales_lh: false,
    sales_lh_cost: false,
    value_lh: false,
    sales_p_lh_cost: false,
    value_p_lh: false,
    lead_lh: false,
    lead_lh_cost: false,
    message_lh: false,
    message_lh_cost: false,
    roas_p_lh: false,
    conversion_p_lh: false,
    lead: true,
    lead_cost: true,
    messages: true,
    messages_cost: true,
    impression: true,
    cpm: true,
    clicks: true,
    ctr: true,
    conversion: true,
    connect_rate: true,
    pageview: true,
    pageview_cost: false,
    view_content: true,
    view_content_cost: false,
    add_to_cart: true,
    add_to_cart_cost: false,
    initate_checkout: true,
    initate_checkout_cost: false,
    add_payment_info: true,
    add_payment_info_cost: false,
    roas: true,
    profit: true,
    profit_value: true,
}

const EMPTYCOLUMNS = [
  { label: 'Valor Gasto', filter: "money", name: 'spend' },
  { label: 'Vendas', filter: "number", name: 'sales' },
  { label: 'Custo por Venda', filter: "money", name: 'sales_cost' },
  { label: 'ROAS', filter: "number", posfix: "x", name: 'roas' },
  { label: 'Lucratividade', filter: "number", posfix: "%", name: 'profit' },
  { label: 'Lucro', filter: "money", name: 'profit_value' },
  { label: 'Vendas LH', filter: "number", name: 'sales_lh', tooltip: "Total e CPA das vendas TRACKEADS. Contando CANCELADAS" },
  { label: 'Custo por venda LH', filter: "money", name: 'sales_lh_cost', tooltip: "Total e CPA das vendas TRACKEADS. Contando CANCELADAS" },
  { label: 'Valor LH', filter: "money", name: 'value_lh', tooltip: "Valor total das vendas TRACKEADAS. Contando CANCELADAS" },
  { label: 'Vendas A. LH', filter: "number", name: 'sales_p_lh', tooltip: "Total e CPA das vendas APROVADAS. " },
  { label: 'Custo por venda A. LH', filter: "money", name: 'sales_p_lh_cost', tooltip: "Total e CPA das vendas APROVADAS. " },
  { label: 'Valor A. LH', filter: "money", name: 'value_p_lh', tooltip: "Valor total das vendas APROVADAS." },
  { label: 'Leads LH', filter: "number", name: 'lead_lh', tooltip: "Leads capturados pela Único." },
  { label: 'Custo do Leads LH', filter: "money", name: 'lead_lh_cost', tooltip: "Leads capturados pela Único." },
  { label: 'Conversas LH', filter: "number", name: 'message_lh', tooltip: "Conversas capturadas pela Único." },
  { label: 'Custo da Conversas LH', filter: "money", name: 'message_lh_cost', tooltip: "Conversas capturadas pela Único." },
  { label: 'Roas LH', filter: "number", posfix:"x", name: 'roas_p_lh', tooltip: "Roas feito a partir das VENDAS APROVADAS." },
  { label: 'Tax.Conv', filter: "number", posfix:"%", name: 'conversion_p_lh', tooltip: "Taxa de conversão sobre as VENDAS APROVADAS." },
  { label: 'Leads', filter: "number", name: 'lead' },
  { label: 'Custo do Lead', filter: "money", name: 'lead_cost' },
  { label: 'Conversas Iniciadas', filter: "number", name: 'messages' },
  { label: 'Custo Conversas Iniciadas', filter: "money", name: 'messages_cost' },
  { label: 'Impressoes', filter: "number", name: 'impression' },
  { label: 'CPM', filter: "money", name: 'cpm' },
  { label: 'Cliques', filter: "number", name: 'clicks' },
  { label: 'Custo dosClique', filter: "money", name: 'clicks_cost' },
  { label: 'CTR', filter: "number", name: 'ctr', posfix:"%" },
  { label: 'Tax. Conversão', filter: "number", posfix:"%", name: 'conversion' },
  { label: 'Connect Rate', filter: "number", posfix:"%", name: 'connect_rate' },
  { label: 'Visualizações de Página', filter: "number", name: 'pageview' },
  { label: 'Custo Visualizações de Página', filter: "money", name: 'pageview_cost' },
  { label: 'Visualizações de Conteúdo', filter: "number", name: 'view_content' },
  { label: 'Custo Visualizações de Conteúdo', filter: "money", name: 'view_content_cost' },
  { label: 'Adições ao Carrinho', filter: "number", name: 'add_to_cart' },
  { label: 'Custo Adições ao Carrinho', filter: "money", name: 'add_to_cart_cost' },
  { label: 'Iniciação de Checkout', filter: "number", name: 'initate_checkout' },
  { label: 'Custo Iniciação de Checkout', filter: "money", name: 'initate_checkout_cost' },
  { label: 'Add Info Pagamento', filter: "number", name: 'add_payment_info' },
  { label: 'Custo Add Info Pagamento', filter: "money", name: 'add_payment_info_cost' },
]

export default {
  name: "campaign-dash",
  components: {
    Tabs,
    Account,
    Campaign,
    AdGroup,
    Ad,
    ltkDatePicker,
    Modal,
    MSwitch,
    draggable
  },
  props: ['slug'],
  data() {
    return {
      loading: false,
      accountSelecteds: [],
      campaignsSelecteds: [],
      adGroupSelecteds: [],
      disableMsg: "Você precisa selecionar pelo menos uma campanha!",
      showModalEdit: false,
      filters: {
        data: {
          refresh: false,
          date: [
            moment()
              .add(-0, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
          order: 'desc',
          order_by: 'status',
          tracking: ''
        },
        list: {
          listOrderBy: [
            {
              value: 'status',
              label: 'Ativas'
            },
            {
              value: 'id',
              label: 'Data de Criação'
            },
            {
              value: 'spend',
              label: 'Valor Gasto'
            },
            {
              value: 'sales',
              label: 'Vendas (FBADS / GADS)'
            },
            {
              value: 'sales_lh',
              label: 'Vendas LH'
            },
            {
              value: 'sales_cost',
              label: 'CPA (FBADS / GADS)'
            },
            {
              value: 'sales_lh_cost',
              label: 'CPA LH'
            },
            {
              value: 'roas_lh',
              label: 'ROAS LH'
            },
            {
              value: 'conversion',
              label: 'Conversão (FBADS / GADS)'
            },
            {
              value: 'conversion_lh',
              label: 'Conversão LH'
            }
          ],
          listTrack: [
            {
              value: '',
              label: 'Jornada da Compra'
            },
            {
              value: 'FIRST_PV',
              label: 'Primeiro Clique'
            },
            {
              value: 'LAST_PV',
              label: 'Último Clique'
            },
          ],
          listOrder: [
            {
              value: 'desc',
              label: 'Do Maior para o Menor'
            },
            {
              value: 'asc',
              label: 'Do Menor para o Maior'
            },
          ]
        },
      },
      currentTab: "campaign",
      stats: Object.assign({}, EMPTYSTATE),
      columns: Object.assign([], EMPTYCOLUMNS),
    };
  },
  mounted() {
    if (this.slug) {
      this.currentTab = this.slug
    }

    this.getDashCampaign()
  },
  computed: {
    // FIXME: AJUSTAR ISSO PARA SELECIONAR ACCOUNT
    checkHaveCampaign() {
      return false

      // if (this.campaignsSelecteds.length > 0) { 
      //   return false
      // }

      // if (this.currentTab == 'campaign') {
      //   return false
      // }

      // return true
    },
    reportTabs() {
      let account = 'Conta de Anúncio'
      if (this.accountSelecteds.length > 0) {
        account = `${account} (${this.accountSelecteds.length})`
      }

      let campaigns = 'Campanhas'
      if (this.campaignsSelecteds.length > 0) {
        campaigns = `${campaigns} (${this.campaignsSelecteds.length})`
      }

      let adgroup = 'Conjuntos de Anúncios'
      if (this.adGroupSelecteds.length > 0) {
        adgroup = `${adgroup} (${this.adGroupSelecteds.length})`
      }

      return [
          {
            name: "account",
            title: account,
          },
          {
            name: "campaign",
            title: campaigns,
          },
          {
            name: "adgroup",
            title: adgroup,
          },
          {
            name: "ad",
            title: "Anúncios",
          },
        ]
      },
  },
  watch: {
    slug() {
      if (this.slug) {
        this.currentTab = this.slug
      } 
    },
    currentTab(value) {
      if (this.slug === value) {
        return
      }

      this.$router.push({ name: "CampaignDash", params: { slug: this.currentTab } });
    }
  },
  methods: {
    getDashCampaign() {
      this.loading = true
      getDashCampaign()
        .then((result) => {
          if (result.custom_fields && result.custom_fields.showColumns) {
              this.stats = Object.assign(result.custom_fields.showColumns, EMPTYSTATE)
          } else {
              this.stats = Object.assign({}, EMPTYSTATE)
          }

          if (result.custom_fields && result.custom_fields.orderColumns && result.custom_fields.orderColumns.length > 0) {
              //this.columns =  Object.assign(result.custom_fields.orderColumns , EMPTYCOLUMNS)
              this.columns = result.custom_fields.orderColumns
          } else {
              this.columns = Object.assign([], EMPTYCOLUMNS)
          }
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateDashCampaign() {
      let params = {
        custom_fields: {
          showColumns: this.stats,
          orderColumns: this.columns
        }
      } 
      updateDashCampaign(params)
        .then(() => {
          this.$toast.success({
            title:'Sucesso',
            message:'Editado com sucesso'
          })

          this.showModalEdit = false
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
    },
    forceRefreshData() {
      this.filters.data.refresh = !this.filters.data.refresh 
    },
    addAccount(accountId) {
      this.accountSelecteds.push(accountId)
      // reset campaigns
      this.campaignsSelecteds = []
      // reset adgroup
      this.adGroupSelecteds = []
    },
    removeAccount(accountId) {
      this.accountSelecteds = this.accountSelecteds.filter( e => e !== accountId)
      // reset campaigns
      this.campaignsSelecteds = []
      // reset adgroup
      this.adGroupSelecteds = []
    },
    cleanAccount() {
      this.accountSelecteds = []
      this.campaignsSelecteds = []
      this.adGroupSelecteds = []
    },
    addCampaign(campId) {
      this.campaignsSelecteds.push(campId)
      // reset adgroup
      this.adGroupSelecteds = []
    },
    removeCampaign(campId) {
      this.campaignsSelecteds = this.campaignsSelecteds.filter( e => e !== campId)
      // reset adgroup
      this.adGroupSelecteds = []
    },
    cleanCampaign() {
      this.campaignsSelecteds = []
      this.adGroupSelecteds = []
    },
    cleanAdg() {
      this.adGroupSelecteds = []
    },
    addAdg(adgId) {
      this.adGroupSelecteds.push(adgId)
    },
    removeAdg(adgId) {
      this.adGroupSelecteds = this.adGroupSelecteds.filter( e => e !== adgId)
    },
  },

};
</script>

<style lang="scss" scoped>

.filter-item {
  max-width: 200px;
  .input {
    min-width: 100px;
  }
}

.litem {
  padding: 4px 4px;
  border-bottom: 1px solid #f4f4f4;
}

.drag-handle {
  cursor: pointer;
  padding: 8px 4px;
  color: var(--primary)
}

@media screen and (max-width: 1024px) {
  .filter-item {
    max-width: 100% !important;
  }
}
</style>
